import {
  Inference,
  InferenceErrorCode,
  Maybe,
} from "@/components/graphql/schema.graphql";

const errorsMessageMap: Record<InferenceErrorCode, string> = {
  INVALID_INPUTS_ERROR:
    "One or more inputs are invalid for this model. Check your files and settings, then try again.",
  MODEL_CAPABILITY_MISMATCH:
    "This model doesn't support one of the provided inputs. Try a different model.",
  CONTENT_POLICY_VIOLATION: "Rejected by our content safety system.",
  INPUT_GUARDRAIL_VIOLATION:
    "This request was blocked before it reached the model.",
  PROMPT_INTELLECTUAL_PROPERTY:
    "Your prompt may contain intellectual property references that cannot be processed.",
  NO_MEDIA_GENERATED:
    "The model returned no result. This usually means the prompt or inputs were rejected — try rephrasing your prompt, then run it again.",
  INSUFFICIENT_BALANCE:
    "Not enough creative units to run this generation. Top up your workspace and try again.",
  BALANCE_UNAVAILABLE:
    "We couldn't verify your workspace balance. Try again shortly.",
  INTERNAL_SERVER_ERROR: "Something went wrong. Please try again.",
  // For completeness, as this value is now deprecated.
  DOWNSTREAM_SERVICE_ERROR:
    "A service we rely on is unavailable. Try again shortly.",
  DOWNSTREAM_SERVICE_CLIENT_ERROR: "Something went wrong. We are on it.",
  DOWNSTREAM_SERVICE_SERVER_ERROR:
    "A service we rely on is unavailable. Try again shortly.",
  // Note: Users should never be able to trigger this error, it means our UI schema validation has gaps.
  IMAGE_TOO_SMALL: "Image is too small.",
  // Note: Users should never be able to trigger this error, it means our UI schema validation has gaps.
  IMAGE_TOO_LARGE: "Image is too large.",
  INVALID_IMAGE_SIZE: "Image is too small or too large.",
  VIDEO_TOO_LARGE: "Video is too large.",
  VIDEO_TOO_LONG: "Video is too long.",
  VIDEO_TOO_SHORT: "Video is too short.",
  VIDEO_TOO_SMALL: "Video is too small.",
};

export const getErrorMessage = (
  inference?: Maybe<Pick<Inference, "errorCode" | "errorMessage">>,
) => {
  if (!inference?.errorCode) return undefined;

  const { errorCode, errorMessage } = inference;
  const baseMessage = errorsMessageMap[errorCode];

  // The backend returns errorMessage only for user-facing codes; when present it carries the
  // provider's specific reason, which is more actionable than the generic category copy.
  if (errorMessage) return `${baseMessage} ${errorMessage}`;

  return baseMessage;
};
